import Vue from "vue";
import Vuetify, {
  VApp,
  VAppBar,
  VAppBarNavIcon,
  VAutocomplete,
  VNavigationDrawer,
  VForm,
  VList,
  VListItem,
  VListItemContent,
  VListItemSubtitle,
  VListItemIcon,
  VTextField,
  VTextarea,
  VBtn,
  VSpacer,
  VContent,
  VContainer,
  VRow,
  VCol,
  VLabel,
  VSnackbar,
  VMenu,
  VDialog
} from "vuetify/lib";

Vue.use(Vuetify, {
  components: {
    VApp,
    VAppBar,
    VAppBarNavIcon,
    VAutocomplete,
    VNavigationDrawer,
    VForm,
    VList,
    VListItem,
    VListItemContent,
    VListItemSubtitle,
    VTextField,
    VTextarea,
    VBtn,
    VSpacer,
    VContent,
    VContainer,
    VRow,
    VCol,
    VLabel,
    VSnackbar,
    VMenu,
    VListItemIcon,
    VDialog
  }
});

export default new Vuetify({});
